import script from "./EntryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryPage.vue?vue&type=script&setup=true&lang=js"

import "./EntryPage.vue?vue&type=style&index=0&id=042089d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042089d0"]])

export default __exports__